export function assignPriceZoneToSeats(response) {
  response.seating_arrangements.seats = response.seating_arrangements.seats.map(
    function (x) {
      let priceZone = tc.util.findById(x.price_zone_id, response.price_zones);
      x.color = priceZone?.color;
      x.always_visible = priceZone?.always_visible;
      return x;
    }
  );

  return response.seating_arrangements;
}
